import { ThumbUp } from "components/icons/generated";
import { getDocsUrl } from "utils/getDocsUrl";
import { openFeaturebaseFeedbackWidget } from "utils/featurebase";
import { showAccountDetailsDrawer } from "views/Account/AccountDetailsDrawer";
import { MainNavigationMenuItem } from "components/MainNavigation/types";

import { FEATUREBASE_URL } from "./useSupportGroupDropdownSaaS";
import { showKeyboardShortcutsDrawer } from "../components/layout/SecondaryItems/KeyboardShortcutsDrawer";

export enum MainNavigationSecondaryMenuItemKeys {
  FeedbackSelfHosted = "feedbackSelfHosted",
  ProductUpdates = "productUpdates",
  SupportChat = "supportChat",
  KeyboardShortcuts = "keyboardShortcuts",
  Documentation = "documentation",
  KnowledgeBase = "knowledgeBase",
  RequestFeature = "requestFeature",
  FeedbackDashboard = "feedbackDashboard",
  Status = "status",
  PersonalSettings = "personalSettings",
  AccountDetails = "accountDetails",
  MissionControl = "missionControl",
  ChangeAccount = "changeAccount",
  About = "about",
  Privacy = "privacy",
  Terms = "terms",
  Logout = "logout",
}

const handleOpenSupportChat = () => {
  if (window.Pylon) {
    window.Pylon("show");
  }
};

export const MAIN_NAVIGATION_SECONDARY_MENU_ITEMS: Record<
  MainNavigationSecondaryMenuItemKeys,
  MainNavigationMenuItem
> = {
  [MainNavigationSecondaryMenuItemKeys.FeedbackSelfHosted]: {
    id: MainNavigationSecondaryMenuItemKeys.FeedbackSelfHosted,
    title: "Feedback dashboard",
    icon: ThumbUp,
    href: FEATUREBASE_URL,
  },
  [MainNavigationSecondaryMenuItemKeys.ProductUpdates]: {
    id: MainNavigationSecondaryMenuItemKeys.ProductUpdates,
    title: "Product updates",
    href: `${FEATUREBASE_URL}/changelog`,
  },
  [MainNavigationSecondaryMenuItemKeys.SupportChat]: {
    id: MainNavigationSecondaryMenuItemKeys.SupportChat,
    title: "Support chat",
    onAction: handleOpenSupportChat,
  },
  [MainNavigationSecondaryMenuItemKeys.KeyboardShortcuts]: {
    id: MainNavigationSecondaryMenuItemKeys.KeyboardShortcuts,
    title: "Keyboard shortcuts",
    onAction: showKeyboardShortcutsDrawer,
  },
  [MainNavigationSecondaryMenuItemKeys.Documentation]: {
    id: MainNavigationSecondaryMenuItemKeys.Documentation,
    title: "Documentation",
    href: getDocsUrl(""),
  },
  [MainNavigationSecondaryMenuItemKeys.KnowledgeBase]: {
    id: MainNavigationSecondaryMenuItemKeys.KnowledgeBase,
    title: "Knowledge base",
    href: "https://support.spacelift.io/",
  },
  [MainNavigationSecondaryMenuItemKeys.RequestFeature]: {
    id: MainNavigationSecondaryMenuItemKeys.RequestFeature,
    title: "Request a feature",
    onAction: openFeaturebaseFeedbackWidget,
  },
  [MainNavigationSecondaryMenuItemKeys.FeedbackDashboard]: {
    id: MainNavigationSecondaryMenuItemKeys.FeedbackDashboard,
    title: "Feedback dashboard",
    href: FEATUREBASE_URL,
  },
  [MainNavigationSecondaryMenuItemKeys.Status]: {
    id: MainNavigationSecondaryMenuItemKeys.Status,
    title: "Status",
    href: "https://spacelift.statuspage.io",
  },
  [MainNavigationSecondaryMenuItemKeys.PersonalSettings]: {
    id: MainNavigationSecondaryMenuItemKeys.PersonalSettings,
    title: "Personal settings",
    to: "/personal-settings",
    routeRule: ["/personal-settings"],
  },
  [MainNavigationSecondaryMenuItemKeys.MissionControl]: {
    id: MainNavigationSecondaryMenuItemKeys.MissionControl,
    title: "Mission control",
    to: "/mission-control",
    routeRule: ["/mission-control"],
  },
  // FYI: Menu item has own custom implementation
  // see LoginListNew
  [MainNavigationSecondaryMenuItemKeys.ChangeAccount]: {
    id: MainNavigationSecondaryMenuItemKeys.ChangeAccount,
    title: "Change account",
  },
  // FYI: Menu item has own custom implementation
  // see AccountDetailsMenuItem
  [MainNavigationSecondaryMenuItemKeys.AccountDetails]: {
    id: MainNavigationSecondaryMenuItemKeys.AccountDetails,
    title: "Account details",
    onAction: () => showAccountDetailsDrawer(),
  },
  [MainNavigationSecondaryMenuItemKeys.About]: {
    id: MainNavigationSecondaryMenuItemKeys.About,
    title: "About",
    href: "https://spacelift.io",
  },
  [MainNavigationSecondaryMenuItemKeys.Privacy]: {
    id: MainNavigationSecondaryMenuItemKeys.Privacy,
    title: "Privacy",
    href: getDocsUrl("/legal/privacy"),
  },
  [MainNavigationSecondaryMenuItemKeys.Terms]: {
    id: MainNavigationSecondaryMenuItemKeys.Terms,
    title: "Terms & Conditions",
    href: getDocsUrl("/legal/terms"),
  },
  [MainNavigationSecondaryMenuItemKeys.Logout]: {
    id: MainNavigationSecondaryMenuItemKeys.Logout,
    title: "Logout",
    to: "/logout",
  },
};
